const WHITESPACE_REGEX = /\s/;
function isWhitespaceCharacter(character) {
  return character ? WHITESPACE_REGEX.test(character) : false;
}

export { isWhitespaceCharacter };
//# sourceMappingURL=is-whitespace-character.js.map
